import { SceneItem, SceneItemType } from '@monorepo/types';
import { Flex, Typography } from 'antd';
import React, { FunctionComponent } from 'react';
import {
  AudioOutlined,
  PictureOutlined,
  SoundOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface Props {
  item: SceneItem;
}

const SceneItemTitle: FunctionComponent<Props> = ({ item }) => {
  const { t } = useTranslation();

  const itemTypeLabels = {
    [SceneItemType.Voiceover]: {
      icon: <AudioOutlined />,
      label: t('videoEditor.scene.itemTypes.voiceover'),
    },
    [SceneItemType.Asset]: {
      icon: <PictureOutlined />,
      label: t('videoEditor.scene.itemTypes.asset'),
    },
    [SceneItemType.Audio]: {
      icon: <SoundOutlined />,
      label: t('videoEditor.scene.itemTypes.audio'),
    },
  };

  const title = itemTypeLabels[item.type];

  return (
    <Flex className="scene-item-title" gap={10}>
      {title.icon}
      <Typography.Text>{title.label}</Typography.Text>
    </Flex>
  );
};

export default SceneItemTitle;
